import type { RouteRecordRaw } from 'vue-router';
import { ERouteName } from '~/app/router/routeName.enum';

export const promoPageRoutes: RouteRecordRaw[] = [
  {
    name: ERouteName.PROMO,
    path: '/promo',
    redirect: '/promo/bloggers',
  },

  // {
  //   name: ERouteName.PROMO_BLOGGERS,
  //   path: '/promo/bloggers',
  //   component: () => import('~/pages/promo/bloggers/index.vue').then((r) => r.default || r),
  // },

  {
    name: ERouteName.PROMO_PODELI,
    path: '/promo/podeli',
    component: () => import('~/pages/promo/podeli/index.vue').then((r) => r.default || r),
  },

  {
    name: ERouteName.PROMO_DOLYAME,
    path: '/promo/dolyame',
    component: () => import('~/pages/promo/dolyame/index.vue').then((r) => r.default || r),
  },

  {
    name: ERouteName.PROMO_INSTALLMENT,
    path: '/promo/installment',
    component: () => import('~/pages/promo/installment/index.vue').then((r) => r.default || r),
  },
];
